import React from 'react';

import {
  errorUtil,
  fields,
  formUtil
} from 'iron-forge-react-modules';

import { BaseTier1ReturnAuthorizationModal } from 'modules/layer01';
import { useForm } from 'react-hook-form';
import { Stack } from '@mui/material';
import * as dataService from './dataService';
import * as types from './types';



const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();



export interface IProps {
  returnAuthorizationId: string;

  onClose: () => void;
  onFinish: () => void;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.returnAuthorizationId);
  const [
    triageReturnAuthorization,
    triageReturnAuthorizationTuple
  ] = dataService.useTriageTier1ReturnAuthorization(props.returnAuthorizationId, queryTuple.data.triageWorkflowId);
  const form = useForm<types.IFormState>({
    defaultValues: {
      serialNumber: '',
      technicianComment: ''
    }
  });
  formUtil.useSetFormFields(queryTuple, form.setValue, ['serialNumber']);

  const processSubmit = React.useCallback(
    (formState: types.IFormState) => {
      props.onFinish();
      errorUtil.errorWrap(async () => {
        await triageReturnAuthorization(formState);
      });
    },
    [
      props,
      triageReturnAuthorization
    ]
  );

  const loading = queryTuple.loading || triageReturnAuthorizationTuple.loading;

  return (
    <BaseTier1ReturnAuthorizationModal.FC
      title="Return"
      primaryText="Review and confirm to return the item to customer"
      secondaryText="Review the item before proceeding"
      disableButtons={loading}
      onClose={props.onClose}
      onSubmit={form.handleSubmit(processSubmit)}>
      <Stack>
        <ControlledTextField
          isRequired
          isDisabled
          label="IMEI/ICCID"
          placeholder="Scan or Select Restock SKU"
          fieldKey="serialNumber"
          formControl={form.control} />

        <ControlledTextField
          label="Technician Comment"
          fieldKey="technicianComment"
          formControl={form.control}
          numLines={5} />
      </Stack>
    </BaseTier1ReturnAuthorizationModal.FC>
  );
};
